import moment from "moment-timezone";
import { Moment } from "moment-timezone";
import { SlotStates } from "../../api/models/ScheduleSlotModel";
import CalendarScheduleModel from "../../models/CalendarScheduleModel";
import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";
import EventInfo from "../calendar-slots/EventInfo";
import ScheduleSlotContainer from "./ScheduleSlotContainer";

type ScheduleSlotWeekContainerProps = {
  viewingDate: Moment;
  schedule?: CalendarScheduleModel | null;
  compact?: boolean;
  onSlotClick?: (slot: CalendarScheduleSlotModel) => void;
  shouldModifySlotStateByDate?: boolean;
  cancel?: boolean;
};

export default function ScheduleSlotWeekContainer({
  viewingDate,
  schedule,
  onSlotClick = () => {},
  compact = false,
  cancel,
}: ScheduleSlotWeekContainerProps) {
  const slots = schedule?.slots || [];
  const startOfTheWeek = moment(viewingDate).day(0);
  const dates = [...Array(7)].map((_, i) =>
    startOfTheWeek.clone().add(i, "day")
  );

  return (
    <>
      {slots.map((slot, index) => (
        <ScheduleSlotContainer
          startTime={slot.startTime}
          dayOfWeek={slot.dayOfWeek}
          cypressSelector={"availableDate"}
          viewingDate={viewingDate}
          key={`${slot.startTime}_${index}`}
        >
          <EventInfo
            slot={
              {
                ...slot,
                date: dates[slot.dayOfWeek - 1],
              } as CalendarScheduleSlotModel
            }
            cancel={cancel}
            compact={compact}
            onClick={onSlotClick}
          />
        </ScheduleSlotContainer>
      ))}
    </>
  );
}
